// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1Vthh","detailsBorder":"styles_detailsBorder__3KThy"};